// CadastreInfoModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect, useState } from "react";
import DeviceDetailComponent from "./devicesDetailComponent";

const DeviceDetailModal = ({
  isOpen,
  onClose,
  unit,
  device,
  fetchDevices,
}: any) => {
  const [localDevice, setLocalDevice] = useState(device);
  useEffect(() => {
    setLocalDevice(device);
  }, [device]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-4"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id} - Toestel detail</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <DeviceDetailComponent
            handleCloseParent={onClose}
            deviceInfo={localDevice}
            unit={unit}
            fetchDevices={fetchDevices}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeviceDetailModal;
